import { getLocale } from "../runtime";

const sv_recommended = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rekommenderat`
};

const recommended = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_recommended(inputs)
	return "recommended";
};

export { recommended as "recommended" };